import { none, Option, some } from "widgets-for-react";
import { createButtonData } from "../../utils";
import { linkWrapper } from "../cms/blocks/utils.gen";
import { DownloadBlockStyle } from "../cms/blocks/widgets/downloadBlock.gen";
import { MediaBlockStyle } from "../cms/blocks/widgets/mediaBlock.gen";
import { TextBlockStyle } from "../cms/blocks/widgets/textBlock.gen";
import { CustomBlock } from "../wordpress/types_and_parser/custom_blocks.mod";
import { PublicSite_CustomPageData } from "./application.mod";
import { CustomBlockData } from "./blocks/custom_blocks/types.mod";
import { carouseBlockClasses, ctaBlockClasses, downloadBlockClasses, iframeBlockClasses, mediaBlockClasses, quoteBlockClasses, textBlockClasses, tableBlockClasses } from "./blocks/style.mod";
import { LinkProps } from './blocks/custom_blocks/widgets/linkBlock'
import moment from "moment";
import { QuoteBlockStyle } from "../cms/blocks/widgets/quoteBlock.gen";
import { CarouselBlockItem } from "./blocks/custom_blocks/widgets/carouselBlock";
import { GridHighlightsBlockItem, GridHighlightsBlockStyle } from "./blocks/custom_blocks/widgets/gridHighlightsBlock";
import { GridBlockItem } from "./blocks/custom_blocks/widgets/gridBlock.mod";


export const CustomBlock_To_Widget = (
  c: CustomBlock,
  block_index: number,
  extra_data: PublicSite_CustomPageData
): Option<CustomBlockData> => {
  if (c.kind == 'vidda/themes-overview') {
    const themes_overview: CustomBlockData = {
      kind: 'themesOverviewBlock',
      value: {
        fst: {
          // Block state
          index: block_index, 
          overlayOpen: false, 

          // Block props
          title: c.attrs.title,

          sidebar_title: c.attrs.sidebar_title,
          side_bar_link_text: c.attrs.side_bar_link_text,
          side_bar_link_url: c.attrs.side_bar_link_url,

          sidebar_item1_amount: c.attrs.sidebar_item1_amount,
          sidebar_item1_title: c.attrs.sidebar_item1_title,
          sidebar_item1_intro: c.attrs.sidebar_item1_intro,
          sidebar_item1_image_url: c.attrs.sidebar_item1_image_url,
          sidebar_item1_image_id: c.attrs.sidebar_item1_image_id,

          sidebar_item2_amount: c.attrs.sidebar_item2_amount,
          sidebar_item2_title: c.attrs.sidebar_item2_title,
          sidebar_item2_intro: c.attrs.sidebar_item2_intro,
          sidebar_item2_image_url: c.attrs.sidebar_item2_image_url,
          sidebar_item2_image_id: c.attrs.sidebar_item2_image_id,

          sidebar_item3_amount: c.attrs.sidebar_item3_amount,
          sidebar_item3_title: c.attrs.sidebar_item3_title,
          sidebar_item3_intro: c.attrs.sidebar_item3_intro,
          sidebar_item3_image_url: c.attrs.sidebar_item3_image_url,
          sidebar_item3_image_id: c.attrs.sidebar_item3_image_id,

          sidebar_item4_amount: c.attrs.sidebar_item4_amount,
          sidebar_item4_title: c.attrs.sidebar_item4_title,
          sidebar_item4_intro: c.attrs.sidebar_item4_intro,
          sidebar_item4_image_url: c.attrs.sidebar_item4_image_url,
          sidebar_item4_image_id: c.attrs.sidebar_item4_image_id,

          blocks: c.innerBlocks
        },
        snd: {}
      }
    }
    return some(themes_overview)
  }
  if (c.kind == 'vidda/download') {
    const vidda_download: CustomBlockData = {
      kind: 'downloadsBlock',
      value: {
        fst: {
          index: block_index,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          items: c.innerBlocks.map((downloadItem, index) => {
            return {
              key: index.toString(),
              title: downloadItem.attrs.title,
              text: downloadItem.attrs.file_name,
              file_url: downloadItem.attrs.url
            }
          }),
          useSVGIcons: false
        },
        snd: downloadBlockClasses as DownloadBlockStyle
      }
    }
    return some(vidda_download)
  }
  if (c.kind == 'vidda/time-line') {
    const vidda_time_line: CustomBlockData = {
      kind: 'timeLineBlock',
      value: {
        fst: {
          title: c.attrs.title ? c.attrs.title : undefined,
          intro: c.attrs.intro ? c.attrs.intro : undefined,
          blocks: c.innerBlocks.map(innerBlock => ({
            title: innerBlock.attrs.title ? innerBlock.attrs.title : undefined,
            has_link: innerBlock.attrs.has_link ? innerBlock.attrs.has_link : undefined,
            image_id: innerBlock.attrs.image_id ? innerBlock.attrs.image_id : undefined,
            image_url: innerBlock.attrs.image_url ? innerBlock.attrs.image_url : undefined,
            label: innerBlock.attrs.label ? moment(innerBlock.attrs.label) : undefined,
            link_text: innerBlock.attrs.link_text ? innerBlock.attrs.link_text : undefined,
            link_url: innerBlock.attrs.link_url ? innerBlock.attrs.link_url : undefined,
          }))
        },
        snd: {}
      }
    }
    return some(vidda_time_line)
  }
  if (c.kind == 'vidda/text') {
    const vidda_text: CustomBlockData = {
      kind: 'textBlock',
      value: {
        fst: {
          title: c.attrs.title,
          text: c.attrs.text,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          has_show_more: c.attrs.has_show_more
        },
        snd: textBlockClasses as TextBlockStyle
      }
    }

    return some(vidda_text)
  }
  if (c.kind == 'vidda/table') {
    return some({
      kind: 'tableBlock',
      value: {
        fst: {
          block_index: block_index,
          html: c.attrs.html
        },
        snd: tableBlockClasses
      }
    })
  }
  if (c.kind == 'vidda/featured-themes') {
    const vidda_featured_themes: CustomBlockData = {
      kind: 'featuredThemesBlock',
      value: {
        fst: {
          label: c.attrs.label ? c.attrs.label : undefined,
          title: c.attrs.title ? c.attrs.title : undefined,
          intro: c.attrs.intro ? c.attrs.intro : undefined,
          blocks: c.innerBlocks.slice(0, 3).map(innerBlock => ({
            title: innerBlock.attrs.title ? innerBlock.attrs.title : undefined,
            link_url: innerBlock.attrs.link_url ? innerBlock.attrs.link_url : undefined,
            amount: innerBlock.attrs.amount ? innerBlock.attrs.amount : undefined,
            image_id: innerBlock.attrs.image_id ? innerBlock.attrs.image_id : undefined,
            image_src: innerBlock.attrs.image_url ? innerBlock.attrs.image_url : undefined
          }))
        },
        snd: {}
      }
    }
    return some(vidda_featured_themes)
  }
  if (c.kind == 'vidda/media') {
    const vidda_media: CustomBlockData = {
      kind: 'mediaBlock',
      value: {
        fst: c.attrs.type == 'image' ? {
          type: 'image',
          useCookieBar: false,
          caption: c.attrs.caption,
          image: c.attrs.image
        } : {
            type: 'video',
            caption: (c.attrs.caption && c.attrs.caption.length != 0) ? c.attrs.caption : null,
            useCookieBar: true,
            video: {
              id: c.attrs.video.id,
              url: c.attrs.video.url,
              type: c.attrs.video.type,
              frameBorder: c.attrs.video.frameBorder,
              allowFullScreen: c.attrs.video.allowFullScreen
            }
          },
        snd: mediaBlockClasses as MediaBlockStyle
      }
    }
    return some(vidda_media)
  }
  if (c.kind == 'vidda/link-list') {
    const vidda_link_list: CustomBlockData = {
      kind: 'linkListBlock',
      value: {
        fst: {
          index: null,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          items: c.innerBlocks.map((linkItem, index) => {
            let link = linkWrapper({ title: linkItem.attrs.link_text, url: linkItem.attrs.link_url })
            return {
              key: index.toString(),
              title: link.title,
              url: link.url,
              is_link_external: link.is_link_external
            } as LinkProps
          }),
          useSVGIcons: false,
        },
        snd: null
      }
    }
    return some(vidda_link_list)
  }
  if (c.kind == 'vidda/quote') {
    const vidda_quote: CustomBlockData = {
      kind: 'customQuoteBlock',
      value: {
        fst: {
          index: block_index,
          text: c.attrs.text,
          author: c.attrs.author,
          company: c.attrs.company,
          primary_button: c.attrs.primary_button_text && c.attrs.primary_button_url
            ? linkWrapper({ title: c.attrs.primary_button_text, url: c.attrs.primary_button_url })
            : null,
          secondary_button: c.attrs.secondary_button_text && c.attrs.secondary_button_url
            ? linkWrapper({ title: c.attrs.secondary_button_text, url: c.attrs.secondary_button_url })
            : null,
          image: c.attrs.image,
        },
        snd: quoteBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_quote)
  }
  if (c.kind == 'vidda/iframe') {
    return some({
      kind: 'iframeBlock',
      value: {
        fst: {
          index: block_index,
          link: c.attrs.url
        },
        snd: iframeBlockClasses
      }
    } as CustomBlockData)
  }
  if (c.kind == 'vidda/header') {
    const vidda_header: CustomBlockData = {
      kind: 'headerBlock',
      value: {
        fst: {
          blockName: 'vidda/header',
          title: c.attrs.title,
          intro: c.attrs.intro,
          image: c.attrs.image,
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_header)
  }
  if (c.kind == 'vidda/image-text') {
    const vidda_image_text: CustomBlockData = {
      kind: 'imageTextBlock',
      value: {
        fst: {
          blockName: 'vidda/image-text',
          image_position: c.attrs.image_position,
          image: c.attrs.image,
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          tag: c.attrs.tag
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_image_text)
  }
  if (c.kind == 'vidda/grid' || c.kind == 'vidda/grid-with-image') {
    const vidda_grid: CustomBlockData = {
      kind: 'gridBlock',
      value: {
        fst: {
          blockName: 'vidda/grid',
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
          blocks: c.innerBlocks.map(innerBlock => {
            return {
              label: innerBlock.attrs.label,
              title: innerBlock.attrs.title,
              intro: innerBlock.attrs.intro,
              image: innerBlock.attrs.image,
              link: innerBlock.attrs.link_url ? linkWrapper({ title: innerBlock.attrs.link_text ? innerBlock.attrs.link_text : "", url: innerBlock.attrs.link_url }) : undefined
            } as GridBlockItem
          })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_grid)
  }
  if (c.kind == 'vidda/grid-highlights') {
    const vidda_grid: CustomBlockData = {
      kind: 'gridHighlightsBlock',
      value: {
        fst: {
          blockName: 'vidda/grid-highlights',
          title: c.attrs.title,
          intro: c.attrs.intro,
          primary_button:
            c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url
              ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url)
              : null,
          secondary_button:
            c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url
              ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url)
              : null,
          blocks: c.innerBlocks.map((innerBlock) => {
            return {
              title: innerBlock.attrs.title,
              intro: innerBlock.attrs.intro,
              image: innerBlock.attrs.image,
              link: innerBlock.attrs.link_url,
              is_video: innerBlock.attrs.is_video,
              has_gradient: innerBlock.attrs.has_gradient,
              label: innerBlock.attrs.label
            } as GridHighlightsBlockItem
          }),
        },
        snd: textBlockClasses as GridHighlightsBlockStyle,
      },
    }
    return some(vidda_grid)
  }
  if (c.kind == 'vidda/other-themes') {
    const vidda_other_themes: CustomBlockData = {
      kind: 'otherThemesBlock',
      value: {
        fst: {
          title: c.attrs.title,
          grid_items: c.innerBlocks.slice(0, 2).map(innerBlock => ({
            has_link: innerBlock.attrs.has_link,
            image_id: innerBlock.attrs.image_id,
            image_url: innerBlock.attrs.image_url,
            label: innerBlock.attrs.label,
            link_text: innerBlock.attrs.link_text,
            link_url: innerBlock.attrs.link_url,
            title: innerBlock.attrs.title
          }))
        },
        snd: {}
      }
    }
    return some(vidda_other_themes)
  }
  if (c.kind == 'vidda/carousel') {
    const vidda_grid: CustomBlockData = {
      kind: 'carouselBlock',
      value: {
        fst: {
          blockName: 'vidda/carousel',
          blockIndex: block_index,
          label: c.attrs.label,
          title: c.attrs.title,
          intro: c.attrs.intro,
          show_random_items: c.attrs.show_random_items,
          primary_button:
            c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url
              ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url)
              : null,
          blocks: c.innerBlocks.map((innerBlock) => {
            return {
              title: innerBlock.attrs.title,
              intro: innerBlock.attrs.intro,
              image: innerBlock.attrs.image,
              link: innerBlock.attrs.link_url,
              is_video: innerBlock.attrs.is_video,
              label: innerBlock.attrs.label,
            } as CarouselBlockItem
          }),
        },
        snd: carouseBlockClasses,
      },
    }
    return some(vidda_grid)
  }
  if (c.kind == 'vidda/facts-and-image') {
    const vidda_facts_and_image: CustomBlockData = {
      kind: 'factsAndImageBlock',
      value: {
        fst: {
          image_id: c.attrs.image_id ? c.attrs.image_id : undefined,
          image_url: c.attrs.image_url ? c.attrs.image_url : undefined,
          items: c.innerBlocks.map(item => { return { amount: item.attrs.amount, label: item.attrs.label, intro: item.attrs.intro } })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_facts_and_image)
  }
  if (c.kind == 'vidda/cta') {
    const vidda_cta: CustomBlockData = {
      kind: 'ctaBlock',
      value: {
        fst: {
          blockName: 'vidda/cta',
          title: c.attrs.title,
          intro: c.attrs.intro,
          image: c.attrs.image,
          image_position: c.attrs.image_position,
          primary_button: c.attrs.show_primary && c.attrs.primary_button_text && c.attrs.primary_button_url ? createButtonData(c.attrs.primary_button_text, c.attrs.primary_button_url) : null,
          secondary_button: c.attrs.show_secondary && c.attrs.secondary_button_text && c.attrs.secondary_button_url ? createButtonData(c.attrs.secondary_button_text, c.attrs.secondary_button_url) : null,
        },
        snd: ctaBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_cta)
  }
  if (c.kind == 'vidda/image-stack') {
    const vidda_image_stack: CustomBlockData = {
      kind: 'imageStackBlock',
      value: {
        fst: {
          block_index: block_index,
          blockName: 'vidda/image-stack',
          title: c.attrs.title,
          intro: c.attrs.intro,
          items: c.innerBlocks.map(imageBlock => { return { image: imageBlock.attrs.image, caption: imageBlock.attrs.caption } })
        },
        snd: textBlockClasses as QuoteBlockStyle
      }
    }
    return some(vidda_image_stack)
  }
  if (c.kind == 'vidda/sidebar') {
    const sidebar: CustomBlockData = {
      kind: 'sidebarBlock',
      value: {
        fst: {
          title: c.attrs.title ? c.attrs.title : undefined,
          link_text: c.attrs.link_text ? c.attrs.link_text : undefined,
          link_url: c.attrs.link_url ? c.attrs.link_url : undefined,
          blocks: c.innerBlocks.slice(0, 3).map(block => ({
            title: block.attrs.title ? block.attrs.title : undefined,
            image_id: block.attrs.image_id ? block.attrs.image_id : undefined,
            image_url: block.attrs.image_url ? block.attrs.image_url : undefined,
            intro: block.attrs.intro ? block.attrs.intro : undefined,
            percentage: block.attrs.percentage ? block.attrs.percentage : undefined
          }))
        },
        snd: {}
      }
    }
    return some(sidebar)
  }
  if (c.kind == 'vidda/featured-content') {
    const vidda_featured_content: CustomBlockData = {
      kind: 'featuredContentBlock',
      value: {
        fst: {
          blockName: 'vidda/featured-content',
          label: c.attrs.label,
          title: c.attrs.title,
          intro: c.attrs.intro,
          button: c.attrs.show_button && c.attrs.button_url && c.attrs.button_text ? createButtonData(c.attrs.button_text, c.attrs.button_url) : null,
          image_position: c.attrs.image_position,
          image: c.attrs.image
        },
        snd: null
      }
    }
    return some(vidda_featured_content)
  }
  return none() // When block is not supported it returns a none
} 